import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import { ModalComponent, ModalModel } from 'src/app/shared/components/modal/modal.component';
import { addressElements } from '../../enum/address-elements';
import { emptyAddress } from '../../enum/empty-address';
import { AddressItems } from './models/address-Items.model';
import { EditContactService } from 'src/app/pages/contact-profile/edit-contact/services/edit-contact.service';
import { AddSubCategoryComponent } from 'src/app/pages/items/add-sub-category/add-sub-category.component';
import { AddCategoryComponent } from 'src/app/pages/items/add-category/add-category.component';
declare var $: any;
@Component({
    selector: 'app-address-fields',
    templateUrl: './address-fields.component.html',
    styleUrls: ['./address-fields.component.scss'],
    standalone: false
})
export class AddressFieldsComponent implements OnInit, OnDestroy {

  @Input() customerAddressArr: any;
  @Output() outputInputFromChild : EventEmitter<string> = new EventEmitter();
  @Output() updateAddress: EventEmitter<any> = new EventEmitter<any>();
  /**
   * Fires whenever an address actually changes: a field typed or filled by the
   * autocomplete / map picker, the address name, the default address, an address
   * added or removed. Never fires while the stored addresses are loaded into the
   * fields, so a parent can use it to enable "Save" (workspace profile).
   */
  @Output() addressEdited: EventEmitter<void> = new EventEmitter<void>();
  @Input() paddingLeft: boolean;
  @Input() moduleName: any;
  @Input() labelName: any;
  @Input() newUserComponent: any;
  @ViewChild('content', { static: false }) modal;
  @ViewChild('closeformOfConForm2') closeformOfConForm2;
  @ViewChild('clientTypesForm') clientTypesForm;
  @ViewChild('roleForm') roleForm;
  @ViewChild('customFieldForm') customFieldForm;
  @ViewChild('socialLinkForm') socialLinkForm;
  @ViewChild('closesocialbutton') closesocialbutton;
  @ViewChild('addFormOfContactButton2') addFormOfContactButton2;
  @ViewChild('addFormClientTypeButton') addFormClientTypeButton;
  @ViewChild('addRoleContactButton') addRoleContactButton;
  @ViewChild('fnameRef') fnameRef: ElementRef;
  openBulkAction:boolean = false;
  currentIndex:any
  touched = false;
  formOfContactFormSubmit = false;
  citiesListMainArr: any = [];
  formContactListArr:any;
  addressFormate: any;
  formContactListArrData:any;
  addressFormateArr: any = {}
  addressFormateArrView = [];
  addressformArr = Array();
  color:any;
  private _unsubscribeAll: Subject<any> = new Subject();

  public fg: FormGroup;
  public addressItems: AddressItems;
  public lineItems: FormArray
  addContactForm: FormGroup;
  formOfContactForm2: FormGroup;



  constructor(
      private _fb: FormBuilder,
      private translateService: TranslateService,
      public dialog: MatDialog,
      private editContactService: EditContactService,
      private formBuilder: FormBuilder,
      private cdr: ChangeDetectorRef

  ) {

}

  ngOnInit(): void {
    // Stored address fields can hold the literal string "null"/"undefined" (legacy bad data),
    // which then renders as text in the inputs (e.g. City showing "null"). Blank those out so
    // the field shows empty, and a subsequent save writes the cleaned value.
    if (Array.isArray(this.customerAddressArr)) {
      this.customerAddressArr.forEach((addr: any) => {
        if (addr && typeof addr === 'object') {
          Object.keys(addr).forEach((k) => {
            if (addr[k] === 'null' || addr[k] === 'undefined') { addr[k] = ''; }
          });
        }
      });
    }
    this.getAllListing()
    this.contactBasicInfoFormVal()
    this.addressItems = new AddressItems(this.customerAddressArr)
      this.fg = this._fb.group(this.addressItems.validationRules());
        // generate line items
        if(this.customerAddressArr?.length){
            _.each(this.customerAddressArr, (o) => { this.addLineItem(this.customerAddressArr.indexOf(o)); });

        }else{
            // No address passed in — seed one empty address BEFORE adding the line item so the
            // row's [(ngModel)]="customerAddressArr[i].title" has a backing object. Without this,
            // customerAddressArr[0] is undefined and the template throws "reading 'title'".
            if (!Array.isArray(this.customerAddressArr)) { this.customerAddressArr = []; }
            this.customerAddressArr.push(new emptyAddress());
            this.addLineItem(0);
        }

      this.getAddressOrder();
      setTimeout(() => {
          this.fg.patchValue(this.addressItems)
          if (this.customerAddressArr.length < 1) {
              this.customerAddressArr.push(new emptyAddress());
          }
      }, 2000);
  }

  contactBasicInfoFormVal() {
    this.addContactForm = this.formBuilder.group(
      {
        formContactId: [''],
      },
    );
    this.formOfContactForm2 = this.formBuilder.group(
      {
        // `name` was previously required, but the "Add Address Name" modal that uses this
        // form is never shown in the invite-member wizard — the required validator silently
        // invalidated the form with no user-visible error. Removing required here; the
        // addFormOfContactList2() submit guard still returns early if the form is invalid,
        // so the modal's own Save button still validates correctly via formOfContactFormSubmit.
        name: [''],
        color: ['#000000', Validators.required],
        color2: ['#000000']
      },
    );
  
}

get formOfContact(): { [key: string]: AbstractControl } {
    return this.formOfContactForm2?.controls;
  }

  getTranslatedText(key: string): string {
    const translation = this.translateService.instant(key);
    return translation !== key ? translation : '';
  }

  async getAllListing() {
  this.editContactService.formContactList({ label: this.labelName }).pipe(takeUntil(this._unsubscribeAll)).subscribe((val: any) => {
    this.formContactListArr = [];
    this.formContactListArrData = [...val.data];
    setTimeout(() => {
      this.formContactListArr = [...val.data];      
    }, 0);
  });
}

  addFormOfContactList2() {
    this.formOfContactFormSubmit = true;
    if (this.formOfContactForm2.invalid) {
      return
    } else {
      this.editContactService.addformOfContactTypes({...this.formOfContactForm2.value,label:this.labelName,title:this.formOfContactForm2.value.name,module_name:this.moduleName}).pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
        this.closeformOfConForm2.nativeElement.click();
        this.formOfContactForm2.reset();
        this.formOfContactFormSubmit = false;
        this.getAllListing();
      })
    }
  }


  async getAddressOrder() {
      let addressFormatSequance = localStorage.getItem('address_format');
      if (addressFormatSequance) {
          this.addressFormate = addressFormatSequance.split(',');
          this.addressFormate.forEach((addressFormate, index) => {
              this.addressFormateArr[addressFormate] = '';
              this.addressFormateArrView.push(addressFormate)
          })
          this.addressformArr.push(this.addressFormateArr)
      }
      if (this.addressFormateArrView.length <= 0) {
          this.addressFormateArrView = addressElements;
      }
  }

  changeAddField(event, type, ix) {
      if (type == 'addTitle') {
          this.customerAddressArr[ix].title = event
      }

      this.touched = true;
      this.addressEdited.emit();
  }

  addFormOfContact(event: any) {
    if (event.value == 'addFormOfContact') {
      this.addFormOfContactButton2.nativeElement.click();
    }
  }

  async onDropdownOpen(isOpen: boolean, index: number) {
    if (isOpen) {
      await this.getAllListing();
    }
  }


  defaultAddress(ix) {
      const alreadyDefault = this.customerAddressArr[ix]?.default_address == '1';
      this.customerAddressArr.forEach((customerAddressArr, index) => {
          if (index == ix) {
              this.customerAddressArr[index].default_address = '1';
          } else {
              this.customerAddressArr[index].default_address = '0';
          }
      })
      if (!alreadyDefault) {
          this.addressEdited.emit();
      }
  }

  updateSubcategories(obj) {
    const dialogRef = this.dialog.open(AddCategoryComponent, {
      width: "800px",
      data: {...obj,label:this.labelName,module_name:this.moduleName}
    });
    dialogRef.afterClosed().pipe(takeUntil(this._unsubscribeAll)).subscribe(async (dialogResult) => {
      if(dialogResult){
        this.getAllListing()
      }
   
    });
  }

  async removeAddress(id: any) {
      const dialogData = new ModalModel(this.translateService.instant('PROFILE.CONFIRMDELETE'));
      const dialogRef = this.dialog.open(ModalComponent, {
          width: "450px",
          data: dialogData
      });
      dialogRef.afterClosed().pipe(takeUntil(this._unsubscribeAll)).subscribe(async (dialogResult) => {
          if (dialogResult) {
              this.customerAddressArr.splice(id, 1);
              this.lineItems.removeAt(id)
              this.addressEdited.emit();
          }
      });
  }

  addAdditionalAddress(event) {
   
      this.customerAddressArr.forEach((customerAddressArr, index) => {
          this.customerAddressArr[index].additional_add_show = false;
          
      })
      
      let newAddr = new emptyAddress();
      if (this.formContactListArr && this.formContactListArr.length === 1) {
          newAddr.title = this.formContactListArr[0].name;
      } else if (this.formContactListArr && this.formContactListArr.length > 1) {
          newAddr.title = "";
      }
      
      this.customerAddressArr.push(newAddr);
      this.citiesListMainArr.push([]);
      this.addLineItem(this.customerAddressArr.length-1);
      let index = this.customerAddressArr.length-1;
      this.sendBlurAction(index);
      this.addressEdited.emit();
  }


public addLineItem(_index): void {
    this.lineItems = this.fg.get('lineItems') as FormArray;

    const lineItem = this._fb.group(this.addressItems.lineItemValidationRules());
    // Each field writes straight back into the shared address object. A write of the
    // value already stored (the initial fill from the saved address) is not an edit;
    // anything else — typing, the autocomplete, the map picker — is, and is reported.
    // The row's position is looked up when the value arrives, not when the row is
    // created: after an address is deleted the rows below it move up, and a position
    // captured at creation would write into the neighbouring address.
    const syncedFields = ['formattedAddress', 'city', 'country', 'state', 'postal_code', 'street_name', 'interior_number', 'house_number'];
    syncedFields.forEach((field) => {
      lineItem.get(field)?.valueChanges
        .pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
          const position = this.lineItems.controls.indexOf(lineItem);
          const address = position > -1 ? this.customerAddressArr?.[position] : null;
          if (!address) {
            return; // the row was removed
          }
          const changed = AddressFieldsComponent.normalise(address[field]) !== AddressFieldsComponent.normalise(value);
          address[field] = value;
          if (changed) {
            this.addressEdited.emit();
          }
        });
    });
    this.lineItems.push(lineItem);


}

/** null / undefined / '' all mean "empty"; numbers and strings compare as trimmed text. */
private static normalise(value: any): string {
    if (value === null || value === undefined) { return ''; }
    if (typeof value === 'object') { return JSON.stringify(value); }
    return String(value).trim();
}
sendBlurAction(index) {
    this.outputInputFromChild.emit(index);
}

async removeItem(i, type) {
    const dialogData = new ModalModel(this.translateService.instant('PROFILE.CONFIRMDELETE'));
    const dialogRef = this.dialog.open(ModalComponent, {
      width: "450px",
      data: dialogData
    });
    dialogRef.afterClosed().pipe(takeUntil(this._unsubscribeAll)).subscribe(async (dialogResult) => {
      if (dialogResult) {

        
        if (type == 'deleteformContact') {
          this.deleteformContact(i)
        }
        
        if (type == 'Delete_Address') {
          this.customerAddressArr.splice(i, 1);
          this.lineItems.removeAt(i);
          this.addressEdited.emit();
        }
      }
    });
  }

  deleteformContact(id) {
    this.editContactService.deleteformOfContactTypes(id).pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
      this.getAllListing();
    })
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }

  changeColor(event) {
    this.color = event?.target?.value;
    this.formOfContactForm2?.controls['color'].setValue(event?.target?.value);
  }

  changeColor1(event) {
    this.color = event?.target?.value ? ('#' + event?.target?.value.replace(/#/g, "")) : null;
    this.formOfContactForm2?.controls['color'].setValue(this.color);
  }
  openBulkActionPopup(event,i){
    this.currentIndex = i
      event.stopPropagation();
      this.formContactListArr.map((x,index)=>{
        if(i === index){
          this.openBulkAction = !this.openBulkAction
        } 
      })
      
    }

}
